import { useEffect, useState } from "react";
import { PersonIcon } from "./icons";
import type { Theme } from "./theme";

const AI_TASKS = ["Structure inputs", "Surface patterns", "Draft scorecards", "Check consistency"];

const HUMAN_TASKS = ["Interpret context", "Challenge evidence", "Decide", "Own outcome"];

export function AIDiagram({ theme }: { theme: Theme }) {
  const [pulse, setPulse] = useState(0);

  useEffect(() => {
    const t = window.setInterval(() => setPulse((p) => p + 1), 1600);
    return () => window.clearInterval(t);
  }, []);

  return (
    <div
      style={{
        border: `1px solid ${theme.border}`,
        borderRadius: theme.radius * 1.5,
        background: theme.surface,
        padding: 28,
        position: "relative",
        minHeight: 420,
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 24 }}>
        <div
          style={{
            fontSize: 11,
            fontFamily: theme.mono,
            color: theme.fgMute,
            letterSpacing: 0.4,
          }}
        >
          AI LAYER
        </div>
        <div
          style={{
            fontSize: 11,
            fontFamily: theme.mono,
            color: theme.fgMute,
            letterSpacing: 0.4,
          }}
        >
          HUMAN LAYER
        </div>
      </div>
      <div style={{ position: "relative", height: 340 }}>
        <div
          style={{
            position: "absolute",
            left: "50%",
            top: 0,
            bottom: 0,
            width: 0,
            borderLeft: `1px dashed ${theme.border}`,
          }}
        />

        {AI_TASKS.map((t, i) => {
          const pulsing = (pulse + i) % AI_TASKS.length === 0;
          return (
            <div
              key={t}
              data-testid={`ai-task-${i}`}
              data-pulsing={pulsing || undefined}
              style={{
                position: "absolute",
                left: 0,
                top: i * 80,
                width: "calc(50% - 14px)",
                padding: "10px 14px",
                background: theme.bg,
                border: `1px solid ${theme.border}`,
                borderRadius: theme.radius,
                fontSize: 13,
                color: theme.fg,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {t}
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: 3,
                  background: pulsing ? theme.accent : theme.border,
                  transition: "background .3s",
                }}
              />
            </div>
          );
        })}

        {HUMAN_TASKS.map((t, i) => (
          <div
            key={t}
            style={{
              position: "absolute",
              right: 0,
              top: i * 80,
              width: "calc(50% - 14px)",
              padding: "10px 14px",
              background: theme.bg,
              border: `1px solid ${theme.accent}`,
              borderRadius: theme.radius,
              fontSize: 13,
              color: theme.fg,
              fontWeight: 500,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {t}
            <PersonIcon color={theme.accentFg} />
          </div>
        ))}
      </div>
    </div>
  );
}
